const KEY = "guest_shortlist_v1";

export function loadGuestShortlist(): (string | number)[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveGuestShortlist(ids: (string | number)[]) {
  try {
    localStorage.setItem(KEY, JSON.stringify(ids));
  } catch {}
}

export function toggleGuestShortlist(ids: (string | number)[], propertyId: string | number) {
  const exists = ids.some((x) => String(x) === String(propertyId));
  const next = exists ? ids.filter((x) => String(x) !== String(propertyId)) : [...ids, propertyId];
  saveGuestShortlist(next);
  return next;
}
